import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { translate } from '../i18n/messages';

const STORAGE_KEY = 'dashboard_locale';

export function readStoredLocale() {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s === 'en' || s === 'sv') return s;
  } catch (_) {
    /* ignore */
  }
  return null;
}

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => readStoredLocale() || 'en');

  const setLocale = useCallback((next) => {
    const l = next === 'sv' ? 'sv' : 'en';
    setLocaleState(l);
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch (_) {
      /* ignore */
    }
  }, []);

  const t = useCallback((path, vars) => translate(locale, path, vars), [locale]);

  const value = useMemo(() => ({ locale, setLocale, t }), [locale, setLocale, t]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return ctx;
}
